import { useEffect, useState } from "react"
import { homeTaskApi } from "../../../../../../api"
import s from './index.module.css'

export const TypeTask = ({ type }) => {
  const [types, setTypes] = useState({})
  useEffect(() => { homeTaskApi.getTypes().then(res => setTypes(res.data)) }, [])
  return <h3 className={s.title}>{types ? types[type] : ''}</h3>
}